import React from 'react';
import WelcomePage from './WelcomePage.jsx';

function App() {
  return <WelcomePage />;
}

export default App;
